import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mh"
}
const _hoisted_2 = { class: "mh-grid" }
const _hoisted_3 = { class: "mh-col" }
const _hoisted_4 = { class: "mh-card" }
const _hoisted_5 = { class: "mh-h" }
const _hoisted_6 = { class: "seg" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mh-time" }
const _hoisted_9 = {
  key: 0,
  class: "mh-lock",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "mh-mm" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "mh-none"
}
const _hoisted_13 = {
  key: 0,
  class: "mh-none"
}
const _hoisted_14 = { class: "mh-wsgrid" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "mh-ws-h" }
const _hoisted_17 = {
  key: 0,
  class: "mh-lock",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "mh-ws-m" }
const _hoisted_19 = {
  key: 0,
  class: "mh-more"
}
const _hoisted_20 = {
  key: 1,
  class: "mh-muted"
}
const _hoisted_21 = { class: "mh-ws-s" }
const _hoisted_22 = {
  key: 0,
  class: "mh-next"
}
const _hoisted_23 = { class: "mh-col" }
const _hoisted_24 = { class: "mh-card" }
const _hoisted_25 = { class: "mh-h" }
const _hoisted_26 = { class: "mh-sub" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "mh-mm" }
const _hoisted_29 = { class: "mh-overdue" }
const _hoisted_30 = { class: "mh-sub" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "mh-mm" }
const _hoisted_33 = {
  key: 1,
  class: "mh-none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_forge_daily_digest = _resolveComponent("forge-daily-digest")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_forge_daily_digest, {
          "in-meetings": "",
          onOpenMeeting: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-meeting', $event))),
          onOpenItem: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('open-item', $event)))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", null, [
                  _createVNode(_component_svg_icon, { icon: "calendar" }),
                  _cache[4] || (_cache[4] = _createTextVNode("My Week", -1))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.scope == 'mine' ? 'on' : ''),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scope = 'mine'))
                  }, "My Meetings (" + _toDisplayString(_ctx.weekMine.length) + ")", 3),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.scope == 'all' ? 'on' : ''),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scope = 'all'))
                  }, "All Teams (" + _toDisplayString(_ctx.weekAll.length) + ")", 3)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: day.offset,
                  class: "mh-day"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["mh-dl", day.offset == 0 ? 'today' : ''])
                  }, [
                    _createTextVNode(_toDisplayString(day.label), 1),
                    (day.sub)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(day.sub), 1))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.rows, (row) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: row.key,
                      class: _normalizeClass(["mh-row", row.ended ? 'mh-row-ended' : ''])
                    }, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(row.time), 1),
                      (!row.meeting.Team)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("rect", {
                              x: "4",
                              y: "11",
                              width: "16",
                              height: "10",
                              rx: "2"
                            }, null, -1),
                            _createElementVNode("path", { d: "M8 11V7a4 4 0 0 1 8 0v4" }, null, -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "mh-dot",
                            style: _normalizeStyle({ background: row.color })
                          }, null, 4)),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("b", null, _toDisplayString(row.meeting.Name), 1),
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(row.groupName) + " · " + _toDisplayString(_ctx.recurrenceLabel(row.meeting.RecurrenceType)), 1),
                          (row.zoneNote)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · " + _toDisplayString(row.zoneNote), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-light mh-open",
                        onClick: ($event: any) => (_ctx.$emit('open-meeting', row.meeting))
                      }, "Open", 8, _hoisted_11)
                    ], 2))
                  }), 128)),
                  (!day.rows.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.scope == 'mine' ? 'No meetings for you today.' : 'No meetings today.'), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (!_ctx.weekRows.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.scope == 'mine' ? "You don't have any meetings in the next 7 days." : 'No meetings in the next 7 days.'), 1))
                : _createCommentVNode("", true)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mh-h2" }, "Teams", -1)),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamCards, (g) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: g.key,
                  type: "button",
                  class: "mh-ws",
                  onClick: ($event: any) => (_ctx.$emit('open-group', g.key))
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    (g.key == 'my')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_17, [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("rect", {
                            x: "4",
                            y: "11",
                            width: "16",
                            height: "10",
                            rx: "2"
                          }, null, -1),
                          _createElementVNode("path", { d: "M8 11V7a4 4 0 0 1 8 0v4" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "mh-dot",
                          style: _normalizeStyle({ background: g.color })
                        }, null, 4)),
                    _createElementVNode("b", null, _toDisplayString(g.name), 1),
                    _createVNode(_component_svg_icon, {
                      icon: "chevright",
                      class: "mh-chev"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.meetings.slice(0, 3), (m) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: m.ID
                      }, _toDisplayString(m.Name), 1))
                    }), 128)),
                    (g.meetings.length > 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, "+" + _toDisplayString(g.meetings.length - 3) + " more", 1))
                      : _createCommentVNode("", true),
                    (!g.meetings.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "No meetings yet"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", null, [
                      _createElementVNode("b", null, _toDisplayString(g.openItems), 1),
                      _createTextVNode(" open item" + _toDisplayString(g.openItems == 1 ? '' : 's'), 1)
                    ]),
                    (g.next)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                          _createVNode(_component_svg_icon, { icon: "clock" }),
                          _createTextVNode(_toDisplayString(g.next), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_15))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("h3", null, [
                  _createVNode(_component_svg_icon, { icon: "user" }),
                  _cache[8] || (_cache[8] = _createTextVNode("On Your Plate", -1))
                ])
              ]),
              (_ctx.overdue.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[9] || (_cache[9] = _createTextVNode("Overdue ", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.overdue.length), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overdue, (i) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: i.ID,
                        type: "button",
                        class: "mh-item",
                        onClick: ($event: any) => (_ctx.$emit('open-item', i))
                      }, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("b", null, _toDisplayString(i.Name), 1),
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(i.MeetingName) + " · ", 1),
                            _createElementVNode("em", _hoisted_29, "due " + _toDisplayString(_ctx.dueLabel(i.DueDate)), 1)
                          ])
                        ])
                      ], 8, _hoisted_27))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_30, [
                _createTextVNode(_toDisplayString(_ctx.overdue.length ? 'Coming up' : 'Assigned to you') + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.upcoming.length), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcoming, (i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: i.ID,
                  type: "button",
                  class: "mh-item",
                  onClick: ($event: any) => (_ctx.$emit('open-item', i))
                }, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("b", null, _toDisplayString(i.Name), 1),
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(i.MeetingName), 1),
                      (i.DueDate)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" · due " + _toDisplayString(_ctx.dueLabel(i.DueDate)), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 8, _hoisted_31))
              }), 128)),
              (!_ctx.plate.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_33, "Nothing open is assigned to you."))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}